import React, { useState, useEffect } from "react";
import "./css/HeroSection.css";
import bg from "../assets/images/home8.jpg";

const texts = [
  "EXPERT KITCHEN RENOVATIONS",
  "PROFESSIONAL BATHROOM RENOVATIONS",
  "MODERN BASEMENT RENOVATIONS",
  "CUSTOM HOME EXTENSIONS",
];

const HeroSection = () => {
  const [index, setIndex] = useState(0);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    setIsActive(true);

    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % texts.length);
      setIsActive(false);
      setTimeout(() => setIsActive(true), 300);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % texts.length);
    setIsActive(false);
    setTimeout(() => setIsActive(true), 300);
  };

  const prevSlide = () => {
    setIndex((prev) => (prev - 1 + texts.length) % texts.length);
    setIsActive(false);
    setTimeout(() => setIsActive(true), 300);
  };

  return (
    <div
      className="container-fluid"
      style={{ borderRadius: "40px", marginTop: "20px", marginBottom: "20px" }}
    >
      <div 
        className={`hero-slide  mx-3 d-flex align-items-center justify-content-center ${
          isActive ? "active" : ""
        }`}
        style={{
          backgroundImage: `url(${bg})`,
          borderRadius: "15px",
          height: "700px",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        
      >
        <button
          onClick={prevSlide}
          className="carousel-btn  btn btn-outline-light position-absolute top-80 start-0 translate-middle-y ms-4"
          style={{ fontSize: "2rem", zIndex: 10 }}
        >
          &#10094;
        </button>

        <button
          onClick={nextSlide}
          className="carousel-btn btn btn-outline-light position-absolute top-80 end-0 translate-middle-y me-4"
          style={{ fontSize: "2rem", zIndex: 10 }}
        >
          &#10095;
        </button>

        <div
          className={`hero-overlay p-4 rounded text-center mt-4 mx-auto ${
            isActive ? "active" : ""
          }`}
        >
          <h1 className="display-5 text-white fw-bold fade-text ">
            {texts[index]} <br />
            <span className="text-gold">IN TORONTO & GTA</span>
          </h1>
          <a href="/contact" className="btn quote-btn1 quote-btn mt-4">
            Get Quote Now
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
